import { useSelector } from "react-redux";

import { isReadOnlyAuth } from "_core/utils/common";

/**
 * 管理画面の更新系UIを無効化すべきかを返す
 *
 * 「一般（読み取りのみ）権限」と「デモユーザー」は、どちらも更新系を使わせないという点で扱いが同じため、
 * ここで合成して各ページは isUpdateLocked だけを見れば済むようにする。
 * 判定はUX目的で、実際の拒否はサーバー側 admin_auth.py の deny_auth_list が行う。
 *
 * @returns {{isReadOnly: boolean, isDemo: boolean, isUpdateLocked: boolean, lockedClass: string}}
 */
export const useUpdateLock = () => {
    const { tAccount, isDemo } = useSelector((store) => store.transaction);

    const isReadOnly = isReadOnlyAuth(tAccount?.auth);
    const isUpdateLocked = isReadOnly || !!isDemo;

    return {
        isReadOnly,
        isDemo: !!isDemo,
        isUpdateLocked,
        // 既存の「classNameに" disabled"を足す」パターンに合わせるためのユーティリティ
        lockedClass: isUpdateLocked ? " disabled" : "",
    };
};

export default useUpdateLock;
